"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("@jordibosch20/software_tools_package/dist/index");
var _jsxRuntime = require("react/jsx-runtime");
function NotFoundComponent(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.OneSideCommonComponent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
        style: {
          "text-align": "center"
        },
        children: "404 Not Found"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {})]
    })
  });
}
var _default = exports["default"] = NotFoundComponent;